/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pickuppointfee/list/fee-card-content/pickup-point-fee-card-content.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../../public/upgrade/core/session.service';
import * as import10 from '@ngx-translate/core/src/translate.pipe';
import * as import11 from '@ngx-translate/core/src/translate.service';
export class Wrapper_PickupPointFeeCardContentComponent {
  /*private*/ _eventHandler:Function;
  context:import0.PickupPointFeeCardContentComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.PickupPointFeeCardContentComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_model(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.model = currValue;
      this._expr_0 = currValue;
    }
  }
  check_pupMap(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.pupMap = currValue;
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_PickupPointFeeCardContentComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_PickupPointFeeCardContentComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.PickupPointFeeCardContentComponent>;
  _PickupPointFeeCardContentComponent_0_3:Wrapper_PickupPointFeeCardContentComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupPointFeeCardContentComponent_Host0,renderType_PickupPointFeeCardContentComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'pickup-point-fee-card-content',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_PickupPointFeeCardContentComponent0(this.viewUtils,this,0,this._el_0);
    this._PickupPointFeeCardContentComponent_0_3 = new Wrapper_PickupPointFeeCardContentComponent(this.injectorGet(import9.SessionService,this.parentIndex));
    this.compView_0.create(this._PickupPointFeeCardContentComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._PickupPointFeeCardContentComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.PickupPointFeeCardContentComponent) && (0 === requestNodeIndex))) { return this._PickupPointFeeCardContentComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PickupPointFeeCardContentComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const PickupPointFeeCardContentComponentNgFactory:import8.ComponentFactory<import0.PickupPointFeeCardContentComponent> = new import8.ComponentFactory<import0.PickupPointFeeCardContentComponent>('pickup-point-fee-card-content',View_PickupPointFeeCardContentComponent_Host0,import0.PickupPointFeeCardContentComponent);
const styles_PickupPointFeeCardContentComponent:any[] = ([] as any[]);
var renderType_PickupPointFeeCardContentComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_PickupPointFeeCardContentComponent,{});
export class View_PickupPointFeeCardContentComponent0 extends import2.AppView<import0.PickupPointFeeCardContentComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _el_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  /*private*/ _expr_46:any;
  _pipe_translate_0:import10.TranslatePipe;
  /*private*/ _expr_48:any;
  _pipe_translate_1:import10.TranslatePipe;
  /*private*/ _expr_50:any;
  _pipe_translate_2:import10.TranslatePipe;
  /*private*/ _expr_52:any;
  /*private*/ _expr_53:any;
  /*private*/ _expr_54:any;
  /*private*/ _expr_55:any;
  /*private*/ _expr_56:any;
  _pipe_translate_3:import10.TranslatePipe;
  /*private*/ _expr_58:any;
  _pipe_translate_4:import10.TranslatePipe;
  /*private*/ _expr_60:any;
  _pipe_translate_5:import10.TranslatePipe;
  /*private*/ _expr_62:any;
  _pipe_translate_6:import10.TranslatePipe;
  /*private*/ _expr_64:any;
  /*private*/ _expr_65:any;
  _pipe_translate_7:import10.TranslatePipe;
  /*private*/ _expr_67:any;
  _pipe_translate_8:import10.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupPointFeeCardContentComponent0,renderType_PickupPointFeeCardContentComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_46 = import1.UNINITIALIZED;
    this._expr_48 = import1.UNINITIALIZED;
    this._expr_50 = import1.UNINITIALIZED;
    this._expr_52 = import1.UNINITIALIZED;
    this._expr_53 = import1.UNINITIALIZED;
    this._expr_54 = import1.UNINITIALIZED;
    this._expr_55 = import1.UNINITIALIZED;
    this._expr_56 = import1.UNINITIALIZED;
    this._expr_58 = import1.UNINITIALIZED;
    this._expr_60 = import1.UNINITIALIZED;
    this._expr_62 = import1.UNINITIALIZED;
    this._expr_64 = import1.UNINITIALIZED;
    this._expr_65 = import1.UNINITIALIZED;
    this._expr_67 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-md-6'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_6,'span',new import3.InlineArray4(4,'class','car-label','qadata','category'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_4,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_11,'span',new import3.InlineArray4(4,'class','car-label','qadata','amount'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_11,'',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_11,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'%',(null as any));
    this._text_17 = this.renderer.createText(this._el_11,'\n                ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_11,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_11,'\n            ',(null as any));
    this._text_21 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_22 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-md-6'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_25,'span',new import3.InlineArray4(4,'class','car-label','qadata','type'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_28 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_29 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_23,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_30,'span',new import3.InlineArray4(4,'class','car-label','qadata','applyTo'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(this._el_30,'',(null as any));
    this._text_34 = this.renderer.createText(this._el_23,'\n        ',(null as any));
    this._text_35 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-md-12'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n            ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'p',new import3.InlineArray2(2,'style','word-break: break-word;'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_38,'span',new import3.InlineArray4(4,'class','car-label','qadata','deliveryPoints'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'',(null as any));
    this._text_42 = this.renderer.createText(this._el_38,'',(null as any));
    this._text_43 = this.renderer.createText(this._el_36,'\n        ',(null as any));
    this._text_44 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_45 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_8 = new import10.TranslatePipe(this.parentView.injectorGet(import11.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._el_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._text_45
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_46:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('fees.CATEGORY')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_46,currVal_46))) {
      this.renderer.setText(this._text_8,currVal_46);
      this._expr_46 = currVal_46;
    }
    valUnwrapper.reset();
    const currVal_48:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_1.transform(('fees.category.' + ((this.context.model == null)? (null as any): this.context.model.category)))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_48,currVal_48))) {
      this.renderer.setText(this._text_9,currVal_48);
      this._expr_48 = currVal_48;
    }
    valUnwrapper.reset();
    const currVal_50:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('fees.AMOUNT')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_50,currVal_50))) {
      this.renderer.setText(this._text_13,currVal_50);
      this._expr_50 = currVal_50;
    }
    const currVal_52:any = import3.inlineInterpolate(1,'\n                ',((this.context.model == null)? (null as any): this.context.model.amount),'\n                ');
    if (import3.checkBinding(throwOnChange,this._expr_52,currVal_52)) {
      this.renderer.setText(this._text_14,currVal_52);
      this._expr_52 = currVal_52;
    }
    const currVal_53:any = (this.context.model.amountType != 'PERCENTAGE');
    if (import3.checkBinding(throwOnChange,this._expr_53,currVal_53)) {
      this.renderer.setElementProperty(this._el_15,'hidden',currVal_53);
      this._expr_53 = currVal_53;
    }
    const currVal_54:any = (this.context.model.amountType != 'FIXED');
    if (import3.checkBinding(throwOnChange,this._expr_54,currVal_54)) {
      this.renderer.setElementProperty(this._el_18,'hidden',currVal_54);
      this._expr_54 = currVal_54;
    }
    const currVal_55:any = import3.inlineInterpolate(1,'',this.context.getCurrencyCode(),'');
    if (import3.checkBinding(throwOnChange,this._expr_55,currVal_55)) {
      this.renderer.setText(this._text_19,currVal_55);
      this._expr_55 = currVal_55;
    }
    valUnwrapper.reset();
    const currVal_56:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('common.TYPE')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_56,currVal_56))) {
      this.renderer.setText(this._text_27,currVal_56);
      this._expr_56 = currVal_56;
    }
    valUnwrapper.reset();
    const currVal_58:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_4.transform(('fees.amount.' + ((this.context.model == null)? (null as any): this.context.model.paymentType)))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_58,currVal_58))) {
      this.renderer.setText(this._text_28,currVal_58);
      this._expr_58 = currVal_58;
    }
    valUnwrapper.reset();
    const currVal_60:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('fees.APPLY_TO')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_60,currVal_60))) {
      this.renderer.setText(this._text_32,currVal_60);
      this._expr_60 = currVal_60;
    }
    valUnwrapper.reset();
    const currVal_62:any = import3.inlineInterpolate(1,'\n                ',valUnwrapper.unwrap(this._pipe_translate_6.transform(('fees.applyTo.' + ((this.context.model == null)? (null as any): this.context.model.origin)))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_62,currVal_62))) {
      this.renderer.setText(this._text_33,currVal_62);
      this._expr_62 = currVal_62;
    }
    const currVal_64:boolean = ((!this.context.model.pickupPointOids || (this.context.model.pickupPointOids.length == 0)) || (this.context.model.oid == 0));
    if (import3.checkBinding(throwOnChange,this._expr_64,currVal_64)) {
      this.renderer.setElementProperty(this._el_36,'hidden',currVal_64);
      this._expr_64 = currVal_64;
    }
    valUnwrapper.reset();
    const currVal_65:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('companyRequest.DELIVERY_POINTS')),':');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_65,currVal_65))) {
      this.renderer.setText(this._text_41,currVal_65);
      this._expr_65 = currVal_65;
    }
    valUnwrapper.reset();
    const currVal_67:any = import3.inlineInterpolate(1,' ',((this.context.model.oid == 0)? valUnwrapper.unwrap(this._pipe_translate_8.transform('common.ALL')): this.context.getPickupNames()),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_67,currVal_67))) {
      this.renderer.setText(this._text_42,currVal_67);
      this._expr_67 = currVal_67;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pickuppointfee/list/fee-card-content/pickup-point-fee-card-content.component.ngfactory.ts